// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty-content[data-v-1887cc6e]{max-width:640px}.empty-content_description[data-v-1887cc6e]{text-align:center;margin-top:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
